/* eslint-disable max-len */

/* eslint-disable react/react-in-jsx-scope */
import
{ useMemo } from 'react';

const ListDataELibrary = (dataAPI) => {
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'number',
        width: 20,
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 110,
      },
      {
        Header: 'Total Enrolled',
        accessor: 'total',
        width: 110,
      },
    ], [],
  );

  const data = [];
  const rows = () => {
    for (let i = 0; i < dataAPI.length; i += 1) {
      data.push({
        id: dataAPI[i]?.id ?? '',
        number: `${i + 1}`,
        name: dataAPI[i]?.course_title ?? '',
        total: `${dataAPI[i]?.total_enroll}` ?? '',
      });
    }
  };

  rows();
  const partnerListTableData = { tableHeaderData: columns, tableRowsData: data };
  return partnerListTableData;
};

export default ListDataELibrary;
